import { j as T } from "./jsx-runtime-B6kdoens.js";
import { createContext as P, useLayoutEffect as K, useEffect as I, useContext as m, useRef as x, useInsertionEffect as Q, useCallback as Z, useMemo as v, forwardRef as tt, Fragment as nt, createElement as et } from "react";
import { a as k, c as ot, L as B, o as at, b as N, d as p, l as it, w as rt, i as st, e as ut, g as L, h as ct, j as lt, k as F, m as H, n as G, p as ft, q as dt, r as A, s as mt, t as gt, u as yt, v as ht, f as R, x as Ct, y as Mt } from "./motion-jk0ivqSc.js";
const O = P({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
}), w = P({}), _ = P(null), Pt = k ? K : I, { schedule: St, cancel: tn } = ot(queueMicrotask, !1);
function q(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
const Vt = P({});
let W = !1;
function bt(t, n, e, o, a) {
  const { visualElement: r } = m(w), u = m(B), s = m(_), f = m(O).reducedMotion, c = x();
  o = o || u.renderer, !c.current && o && (c.current = o(t, {
    visualState: n,
    parent: r,
    props: e,
    presenceContext: s,
    blockInitialAnimation: s ? s.initial === !1 : !1,
    reducedMotionConfig: f
  }));
  const i = c.current, l = m(Vt);
  i && !i.projection && a && (i.type === "html" || i.type === "svg") && wt(c.current, e, a, l), Q(() => {
    i && i.update(e, s);
  });
  const d = x(!!(e[at] && !window.HandoffComplete));
  return Pt(() => {
    i && (i.updateFeatures(), St.render(i.render), d.current && i.animationState && i.animationState.animateChanges());
  }), I(() => {
    i && (!d.current && i.animationState && i.animationState.animateChanges(), d.current && (d.current = !1, W || (W = !0, queueMicrotask(vt))));
  }), i;
}
function vt() {
  window.HandoffComplete = !0;
}
function wt(t, n, e, o) {
  const { layoutId: a, layout: r, drag: u, dragConstraints: s, layoutScroll: f, layoutRoot: c } = n;
  t.projection = new e(t.latestValues, n["data-framer-portal-id"] ? void 0 : U(t.parent)), t.projection.setOptions({
    layoutId: a,
    layout: r,
    alwaysMeasureLayout: !!u || s && q(s),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof r == "string" ? r : "both",
    initialPromotionConfig: o,
    layoutScroll: f,
    layoutRoot: c
  });
}
function U(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : U(t.parent);
}
function xt(t, n, e) {
  return Z(
    (o) => {
      o && t.mount && t.mount(o), n && (o ? n.mount(o) : n.unmount()), e && (typeof e == "function" ? e(o) : q(e) && (e.current = o));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [n]
  );
}
function Lt(t, n) {
  if (N(t)) {
    const { initial: e, animate: o } = t;
    return {
      initial: e === !1 || p(e) ? e : void 0,
      animate: p(o) ? o : void 0
    };
  }
  return t.inherit !== !1 ? n : {};
}
function jt(t) {
  const { initial: n, animate: e } = Lt(t, m(w));
  return v(() => ({ initial: n, animate: e }), [D(n), D(e)]);
}
function D(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const Tt = P({}), pt = Symbol.for("motionComponentSymbol");
function At({ preloadedFeatures: t, createVisualElement: n, useRender: e, useVisualState: o, Component: a }) {
  t && it(t);
  function r(s, f) {
    let c;
    const i = {
      ...m(O),
      ...s,
      layoutId: Rt(s)
    }, { isStatic: l } = i, d = jt(s), C = o(s, l);
    if (!l && k) {
      Wt(i, t);
      const g = Dt(i);
      c = g.MeasureLayout, d.visualElement = bt(a, C, i, n, g.ProjectionNode);
    }
    return T.jsxs(w.Provider, { value: d, children: [c && d.visualElement ? T.jsx(c, { visualElement: d.visualElement, ...i }) : null, e(a, s, xt(C, d.visualElement, f), C, l, d.visualElement)] });
  }
  const u = tt(r);
  return u[pt] = a, u;
}
function Rt({ layoutId: t }) {
  const n = m(Tt).id;
  return n && t !== void 0 ? n + "-" + t : t;
}
function Wt(t, n) {
  const e = m(B).strict;
  if (process.env.NODE_ENV !== "production" && n && e) {
    const o = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? rt(!1, o) : st(!1, o);
  }
}
function Dt(t) {
  const { drag: n, layout: e } = ut;
  if (!n && !e)
    return {};
  const o = { ...n, ...e };
  return {
    MeasureLayout: n != null && n.isEnabled(t) || e != null && e.isEnabled(t) ? o.MeasureLayout : void 0,
    ProjectionNode: o.ProjectionNode
  };
}
function Et(t) {
  function n(o, a = {}) {
    return At(t(o, a));
  }
  if (typeof Proxy > "u")
    return n;
  const e = /* @__PURE__ */ new Map();
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (o, a) => (e.has(a) || e.set(a, n(a)), e.get(a))
  });
}
const j = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function z(t, n, e) {
  for (const o in n)
    !L(n[o]) && !ct(o, e) && (t[o] = n[o]);
}
function It({ transformTemplate: t }, n) {
  return v(() => {
    const e = j();
    return lt(e, n, t), Object.assign({}, e.vars, e.style);
  }, [n]);
}
function kt(t, n) {
  const e = t.style || {}, o = {};
  return z(o, e, t), Object.assign(o, It(t, n)), o;
}
function Bt(t, n) {
  const e = {}, o = kt(t, n);
  return t.drag && t.dragListener !== !1 && (e.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (e.tabIndex = 0), e.style = o, e;
}
const Nt = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function b(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || Nt.has(t);
}
let $ = (t) => !b(t);
function Ft(t) {
  t && ($ = (n) => n.startsWith("on") ? !b(n) : t(n));
}
try {
  Ft(require("@emotion/is-prop-valid").default);
} catch {
}
function Ht(t, n, e) {
  const o = {};
  for (const a in t)
    a === "values" && typeof t.values == "object" || ($(a) || e === !0 && b(a) || !n && !b(a) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && a.startsWith("onDrag")) && (o[a] = t[a]);
  return o;
}
const Y = () => ({
  ...j(),
  attrs: {}
});
function Gt(t, n, e, o) {
  const a = v(() => {
    const r = Y();
    return F(r, n, H(o), t.transformTemplate), {
      ...r.attrs,
      style: { ...r.style }
    };
  }, [n]);
  if (t.style) {
    const r = {};
    z(r, t.style, t), a.style = { ...r, ...a.style };
  }
  return a;
}
function Ot(t = !1) {
  return (e, o, a, { latestValues: r }, u) => {
    const f = (G(e) ? Gt : Bt)(o, r, u, e), c = Ht(o, typeof e == "string", t), i = e !== nt ? { ...c, ...f, ref: a } : {}, { children: l } = o, d = v(() => L(l) ? l.get() : l, [l]);
    return et(e, {
      ...i,
      children: d
    });
  };
}
function _t(t) {
  const n = x(null);
  return n.current === null && (n.current = t()), n.current;
}
function qt(t) {
  const n = L(t) ? t.get() : t;
  return ft(n) ? n.toValue() : n;
}
function Ut({ applyWillChange: t = !1, scrapeMotionValuesFromProps: n, createRenderState: e, onMount: o }, a, r, u, s) {
  const f = {
    latestValues: $t(a, r, u, s ? !1 : t, n),
    renderState: e()
  };
  return o && (f.mount = (c) => o(a, c, f)), f;
}
const X = (t) => (n, e) => {
  const o = m(w), a = m(_), r = () => Ut(t, n, o, a, e);
  return e ? r() : _t(r);
};
function zt(t, n) {
  const e = gt(n);
  e && yt(t, e);
}
function E(t, n, e) {
  const o = Array.isArray(n) ? n : [n];
  for (let a = 0; a < o.length; a++) {
    const r = mt(t, o[a]);
    if (r) {
      const { transitionEnd: u, transition: s, ...f } = r;
      e(f, u);
    }
  }
}
function $t(t, n, e, o, a) {
  var r;
  const u = {}, s = [], f = o && ((r = t.style) === null || r === void 0 ? void 0 : r.willChange) === void 0, c = a(t, {});
  for (const y in c)
    u[y] = qt(c[y]);
  let { initial: i, animate: l } = t;
  const d = N(t), C = dt(t);
  n && C && !d && t.inherit !== !1 && (i === void 0 && (i = n.initial), l === void 0 && (l = n.animate));
  let g = e ? e.initial === !1 : !1;
  g = g || i === !1;
  const S = g ? l : i;
  return S && typeof S != "boolean" && !A(S) && E(t, S, (y, V) => {
    for (const M in y) {
      let h = y[M];
      if (Array.isArray(h)) {
        const J = g ? h.length - 1 : 0;
        h = h[J];
      }
      h !== null && (u[M] = h);
    }
    for (const M in V)
      u[M] = V[M];
  }), f && (l && i !== !1 && !A(l) && E(t, l, (y) => {
    for (const V in y)
      zt(s, V);
  }), s.length && (u.willChange = s.join(","))), u;
}
const Yt = {
  useVisualState: X({
    scrapeMotionValuesFromProps: ht,
    createRenderState: Y,
    onMount: (t, n, { renderState: e, latestValues: o }) => {
      R.read(() => {
        try {
          e.dimensions = typeof n.getBBox == "function" ? n.getBBox() : n.getBoundingClientRect();
        } catch {
          e.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), R.render(() => {
        F(e, o, H(n.tagName), t.transformTemplate), Ct(n, e);
      });
    }
  })
}, Xt = {
  useVisualState: X({
    applyWillChange: !0,
    scrapeMotionValuesFromProps: Mt,
    createRenderState: j
  })
};
function Jt(t, { forwardMotionProps: n = !1 }, e, o) {
  return {
    ...G(t) ? Yt : Xt,
    preloadedFeatures: e,
    useRender: Ot(n),
    createVisualElement: o,
    Component: t
  };
}
const nn = Et(Jt);
export {
  Tt as L,
  O as M,
  _ as P,
  _t as a,
  nn as m,
  Pt as u
};
//# sourceMappingURL=motion-minimal-Crg_qVxv.js.map
